import React, { useState, useRef, useEffect } from "react";
import wadeIcon from "../../../components/Icons/wadeIcon.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { setIsAuthorized } from "../../../redux/login/actions";
import { useDispatch } from "react-redux";
import { getEmailVerify2FAService } from "../../../services/emailVerify2FA.service";
import { getVerify2FAService } from "../../../services/Verify2FA.service";
import { getExistingUserVerify2FAService } from "../../../services/existingUserVerfiy2FA.service";
import { getEmailEnable2FAService } from "../../../services/emailEnable2FA.service";
import VerifiedAccount from "../../../components/Login/Message/VerifiedAccount/VerifiedAccount";

interface OTPInputProps {
  length: number;
  isLoggedInHandler: () => void;
}

const CodeVerification: React.FC<OTPInputProps> = ({
  length,
  isLoggedInHandler,
}) => {
  const [otp, setOTP] = useState<string[]>([]);
  const inputs = useRef<HTMLInputElement[]>([]);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [onSubmit, SetOnSubmit] = useState(false);
  const [validOTP, setValidOTP] = useState(true);
  const [resendCodeMessageStatus, setResendCodeMessageStatus] = useState(false);

  const onDoneButtonClick = () => {
    dispatch(setIsAuthorized(true));
    navigate("/home");
  };
  const onCloseIconClick = () => {
    SetOnSubmit(false);
    dispatch(setIsAuthorized(true));
    navigate("/home");
  };
  useEffect(() => {
    if (inputs.current.length > 0) {
      inputs.current[0].focus();
    }
  }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const value = e.target.value;
    if (isNaN(Number(value))) {
      return;
    }

    const newOTP = [...otp];
    newOTP[index] = value;
    setOTP(newOTP);

    if (value !== "") {
      if (index === length - 1) {
        inputs.current[index].blur();
      } else {
        inputs.current[index + 1].focus();
      }
    }
  };

  const onPaste = (event: React.ClipboardEvent) => {
    const { clipboardData } = event;
    const pastedText = clipboardData.getData("text");
    setOTP(pastedText.split(""));
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    if (e.key === "Backspace" && otp[index] === "" && index !== 0) {
      inputs.current[index - 1].focus();
    }
  };

  const onSubmitButtonHandler = () => {
    if (location.state.verifyType === "microsoft") {
      getVerify2FAService(
        location.state.user_id,
        otp.join(""),
        location.state.email,
        location.state.password
      )
        .then((res) => {
          res.valid ? SetOnSubmit(!onSubmit) : setValidOTP(false);
          setOTP([]);
        })
        .catch((response) => {
          setValidOTP(false);
          setOTP([]);
        });
    } else if (location.state.verifyType === "email") {
      getEmailVerify2FAService(
        location.state.user_id,
        otp.join(""),
        location.state.email,
        location.state.password
      )
        .then((res: any) => {
          res.message === "ok" ? SetOnSubmit(!onSubmit) : setValidOTP(true);
        })
        .catch((response) => {
          setValidOTP(false);
          setResendCodeMessageStatus(false);
          setOTP([]);
        });
    } else if (location.state.verifyType === "existingUser") {
      getExistingUserVerify2FAService(
        location.state.user_id,
        otp.join(""),
        location.state.email,
        location.state.password
      )
        .then((res: any) => {
          res.is_active === true ? SetOnSubmit(!onSubmit) : setValidOTP(true);
        })
        .catch((response) => {
          setValidOTP(false);
          setResendCodeMessageStatus(false);
          setOTP([]);
        });
    }
  };

  const onResendCodeClick = () => {
    setValidOTP(true);
    setResendCodeMessageStatus(true);
    setOTP([]);
    if (
      location.state.verifyType === "email" ||
      location.state.authMethod === "EMAIL"
    ) {
      getEmailEnable2FAService(
        location.state.email,
        location.state.password,
        location.state.user_id
      );
    }
  };
  return (

    <div className="tw-min-h-screen tw-bg-gray-100 tw-flex tw-justify-center tw-items-center tw-p-4 tw-relative">
      {/* Background Image Overlay */}
      <div
        className="tw-absolute tw-inset-0 tw-bg-cover tw-bg-center tw-opacity-10 tw-pointer-events-none"
        style={{ backgroundImage: `url(${wadeIcon})`, backgroundSize: '50%' }}
      />

      {!onSubmit && (
        <div className="tw-bg-white tw-rounded-2xl tw-shadow-2xl tw-overflow-hidden tw-flex tw-flex-col tw-relative tw-w-full tw-max-w-xl tw-z-10">
          {/* Top Accent Line */}
          <div className="tw-h-2 tw-bg-gradient-to-r tw-from-[#03234a] tw-to-[#04346c] tw-w-full"></div>

          <div className="tw-p-8 md:tw-p-10 tw-flex tw-flex-col tw-items-center">
            {/* Logo Section */}
            <div className="tw-mb-8 tw-bg-gray-50 tw-p-4 tw-rounded-full tw-shadow-sm">
              <img src={wadeIcon} alt="Wade Logo" className="tw-h-8" />
            </div>

            {/* Title */}
            <h2 className="tw-text-[#03234a] tw-text-2xl tw-font-bold tw-mb-3 tw-text-center">
              {location.state.verifyType === "microsoft" || location.state.authMethod === "AUTHENTICATOR"
                ? "Authenticator Code"
                : "Email Verification"}
            </h2>

            {/* Description */}
            <p className="tw-text-gray-500 tw-text-center tw-mb-8 tw-text-sm tw-leading-relaxed tw-max-w-xs">
              {location.state.verifyType === "microsoft" || location.state.authMethod === "AUTHENTICATOR"
                ? "Enter the 6-digit code from your Microsoft Authenticator app."
                : "We've sent a 6-digit verification code to your registered email address."}
            </p>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                onSubmitButtonHandler();
              }}
              className="tw-w-full tw-flex tw-flex-col tw-items-center"
            >
              {/* OTP Inputs - Grid Layout */}
              <div className="tw-grid tw-grid-cols-6 tw-gap-2 md:tw-gap-3 tw-mb-8 tw-w-full tw-max-w-sm">
                {Array(length)
                  .fill("")
                  .map((_, index) => (
                    <input
                      key={index}
                      type="text"
                      maxLength={1}
                      value={otp[index] || ""}
                      onChange={(e) => handleChange(e, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      onPaste={(e) => onPaste(e)}
                      ref={(ref) =>
                        (inputs.current[index] = ref as HTMLInputElement)
                      }
                      className="tw-w-full tw-aspect-square tw-text-center tw-text-xl md:tw-text-2xl tw-font-bold tw-text-[#03234a] tw-bg-gray-50 tw-border-2 tw-border-gray-200 tw-rounded-lg focus:tw-outline-none focus:tw-border-[#03234a] focus:tw-ring-4 focus:tw-ring-[#03234a]/10 tw-transition-all"
                      autoFocus={index === 0}
                    />
                  ))}
              </div>

              {/* Error Messages */}
              {(!validOTP || resendCodeMessageStatus) && (
                <div
                  className={`tw-flex tw-items-center tw-justify-center tw-p-3 tw-rounded-lg tw-w-full tw-mb-6 ${!validOTP
                    ? "tw-bg-red-50 tw-text-red-600"
                    : "tw-bg-blue-50 tw-text-blue-600"
                    }`}
                >
                  <span className="tw-text-sm tw-font-medium">
                    {!validOTP
                      ? "Invalid code. Please try again."
                      : "New code sent to your email."}
                  </span>
                </div>
              )}

              {/* Submit Button */}
              <button
                type="submit"
                disabled={otp.length !== length}
                className="tw-w-full tw-h-12 tw-bg-[#03234a] tw-text-white tw-font-bold tw-tracking-wide tw-rounded-xl hover:tw-bg-[#052d5e] focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-[#03234a] disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-transition-all tw-shadow-lg hover:tw-shadow-xl hover:-tw-translate-y-0.5 active:tw-translate-y-0 tw-mb-6"
              >
                VERIFY & LOGIN
              </button>
            </form>

            {/* Resend Link */}
            {(location.state.verifyType === "email" ||
              location.state.authMethod === "EMAIL") && (
                <div className="tw-text-sm tw-text-gray-500">
                  Didn't receive the code?{" "}
                  <button
                    type="button"
                    onClick={onResendCodeClick}
                    className="tw-text-[#03234a] tw-font-bold hover:tw-underline focus:tw-outline-none tw-bg-transparent tw-border-none tw-p-0 tw-ml-1"
                  >
                    Resend
                  </button>
                </div>
              )}
          </div>
        </div>
      )}
      <VerifiedAccount
        show={onSubmit}
        onHide={onCloseIconClick}
        onDoneButtonClick={onDoneButtonClick}
      />
    </div>
  );
};

export default CodeVerification;
